import { Directive, ElementRef, inject, OnDestroy, OnInit } from '@angular/core';
import { BannerLayoutService } from 'src/app/core/services/banner/banner-layout.service';

/**
 * Reports a fixed banner's rendered height to BannerLayoutService, which exposes it as
 * `--app-banner-height` for the `.banner-page` top offset. Re-measures on resize, so larger text
 * sizes or a wrapped title still push the page content clear of the banner.
 *
 * Usage: `<div class="ss-banner" appBannerHeight>`.
 */
@Directive({
  selector: '[appBannerHeight]',
  standalone: true,
})
export class BannerHeightDirective implements OnInit, OnDestroy {
  private readonly element: ElementRef<HTMLElement> = inject(ElementRef);
  private readonly bannerLayoutService = inject(BannerLayoutService);
  private resizeObserver?: ResizeObserver;

  ngOnInit(): void {
    const el: HTMLElement = this.element.nativeElement;
    this.bannerLayoutService.setHeight(el.getBoundingClientRect().height);
    if (typeof ResizeObserver === 'undefined') return;
    this.resizeObserver = new ResizeObserver(() => {
      this.bannerLayoutService.setHeight(el.getBoundingClientRect().height);
    });
    this.resizeObserver.observe(el);
  }

  ngOnDestroy(): void {
    this.resizeObserver?.disconnect();
  }
}
